import React, { useEffect, useRef, useState } from 'react';
import P from 'prop-types';
import { Box } from '@nerdwallet/currency';
import styles from './group-button.module.scss';

function isSelected(buttonList, buttonValue) {
  return buttonList.find((i) => i.value === buttonValue);
}

function removeFalsyEntries(objSource) {
  const obj = { ...objSource };
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const value in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(value) && !obj[value]) {
      delete obj[value];
    }
    if (value in obj && !obj[value]) {
      delete obj[value];
    }
  }
  return obj;
}

export const GroupButton = ({ buttons = [], handle, initState = {} }) => {
  const [selected, setSelected] = useState([]);
  const handleRef = useRef();

  // Because we want to call the handle when the setState is done.
  useEffect(() => {
    if (handleRef.current) {
      // Parsing from array to Object; e.g: { bold: true }
      const result = {
        ...selected.reduce(
          (acc, current) => ({ ...acc, [current.value]: true }),
          {}
        ),
      };
      handleRef.current(result);
    }
  }, [selected]);

  useEffect(() => {
    // Loading saved values from server
    const cleanedValues = removeFalsyEntries(initState);
    setSelected(
      buttons.filter((button) => {
        return Object.keys(cleanedValues).includes(button.value);
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (_, button) => {
    if (button?.multiple) {
      setSelected((state) =>
        isSelected(state, button.value)
          ? state.filter((i) => i.value !== button.value)
          : [...state, button]
      );
    } else {
      setSelected((state) => [...state.filter((i) => i.multiple), button]);
    }
    // Because setState is asynchronous and we won`t have the precise values to
    // give back in the callback
    handleRef.current = handle;
  };

  return (
    <Box className={styles.container}>
      {buttons.map((button) => (
        <button
          type="button"
          key={button.value}
          name={button.value}
          className={
            isSelected(selected, button.value)
              ? `${styles.customButton} ${styles.active}`
              : `${styles.customButton}`
          }
          onClick={(e) => handleClick(e, button)}
        >
          {button?.component || button?.label}
        </button>
      ))}
    </Box>
  );
};

GroupButton.propTypes = {
  buttons: P.arrayOf(
    P.shape({
      label: P.string,
      value: P.string,
    })
  ),
  handle: P.func,
  initState: P.shape({
    label: P.string,
    value: P.string,
  }),
};
